import { render } from "./WithAllowHalf.vue?vue&type=template&id=5ab279c0"
import script from "./WithAllowHalf.vue?vue&type=script&lang=js"
export * from "./WithAllowHalf.vue?vue&type=script&lang=js"
script.render = render

export default script